// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"313a8de9","648":"50acb814"}[chunkId] + ".chunk.js";
};